import { Pill, TextSizes } from "@smartsuite/react-ui/lib";
import styled from "styled-components";
import {
  Colors,
  GrayColors,
  IconColorNames,
  TextColorNames,
} from "@smartsuite/types";
import type { PartialButtonStylesType } from "@smartsuite/react-ui/lib/components/buttons/Button/Button.types";

export const JsonEditor = styled.div`
  border: 1px solid var(--G-1-5, ${GrayColors["G-1-5"]});
  border-radius: 5px;
  padding: 10px;

  &.is-error {
    border: 1px solid ${Colors.bRed};
  }
`;

export const Text = styled.div<{ marginRight?: string }>`
  display: inline-flex;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  margin-right: ${({ marginRight }) =>
    marginRight !== undefined ? marginRight : "0"};
  overflow-wrap: anywhere;
`;

export const PillWrapper = styled(Pill)`
  margin-right: 5px;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
`;

export const DropdownItem = styled.div<{ selected: boolean }>`
  display: flex;
  padding: ${({ selected }) => (selected ? "0 0 0 8px" : "8px")};
  cursor: pointer;
  justify-content: space-between;
  background-color: ${GrayColors["G-0"]};
  align-items: baseline;
  &:hover {
    background-color: ${({ selected }) =>
      selected ? GrayColors["G-0"] : GrayColors["G-0-5"]};
  }

  span {
    display: flex;
    align-items: center;
  }
`;

export const DropdownText = styled.div`
  display: inline-flex;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  padding-left: 8px;
  line-height: 18px;
`;

export const DropdownSelected = styled.div`
  display: inline-flex;
`;

export const StyledRemoveButton = styled.div`
  opacity: 0;
  overflow: hidden;
  position: relative;
  display: inline-flex;
  transition: width 250ms ease-in-out, opacity 350ms linear;
  min-width: 32px;
`;

export const Root = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
  min-height: 29px;
  padding-left: 8px;
  font-family: monospace, sans-serif;
  border-radius: 8px;
  border: 1px solid transparent;

  &:hover {
    background-color: ${GrayColors["G-0-5"]};
    border-color: ${GrayColors["G-1"]};
    ${StyledRemoveButton} {
      opacity: 1;
      transition: opacity 200ms ease-in-out;
    }
  }
  &.invalid {
    color: ${Colors.dRed};
  }

  span {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const buttonStyles: PartialButtonStylesType = {
  background: GrayColors["G-0"],
  borderColor: GrayColors["G-1-5"],
  borderWidth: 1,
  iconColor: IconColorNames.dark,
  borderRadius: 5,
  textColor: "black",
  textSize: TextSizes.XS,
  textWeight: "medium",
  height: 24,
};

export const VerticalLine = styled.div`
  display: inline-flex;
  height: 100%;
  min-height: 30px;
  margin-left: 15px;
  padding-left: 8px;
  padding-right: 6px;
  border-left: 1px solid ${GrayColors["G-1-5"]};
  flex-direction: column;
  max-width: calc(100% - 10px);
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 2px;
  margin-left: 25px;
  position: relative;
  bottom: 0;
  left: -18px;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const ReconfigureSection = styled.div`
  display: flex;
  height: 34px;
  width: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 6px;
  cursor: pointer;
`;

export const Space = styled.div`
  width: 5px;
`;
